// extracted by mini-css-extract-plugin
module.exports = {"py22p5":"py22p5","b1cz5p4l":"b1cz5p4l"};